





























































































import Vue, { PropType } from "vue";
import moment from "moment";
import RecordCard from "@/components/vue-components/RecordCard.vue";
import LoadMore from "@/components/vue-components/LoadMore.vue";
import IconBookingArrowRight from "@/assets/icons/IconBookingArrowRight.vue";
import { CompanyObject } from "./types/index";
import type { RecordObject } from "./types/index";

const PAGE_SIZE = 5;

/**
 * This view is rendered twice on the same page (future and past), so the ids
 * wiring the heading and the menu to their controls have to be unique.
 */
let instanceCount = 0;

export default Vue.extend({
  name: "AppointmentsDashboard",
  data() {
    instanceCount += 1;

    return {
      timezone: moment.tz.guess() as string,
      /**
       * The marketplace (vello.fi), not the pro app (pro.vello.fi): booking a
       * time is an end-customer action and pro is the business-side host.
       */
      baseUrl: process.env.VUE_APP_MARKETPLACE_URL as string,
      isOpen: false as boolean,
      instanceId: `appointments-${instanceCount}`,
      pageSize: PAGE_SIZE,
      visibleCount: PAGE_SIZE
    };
  },
  components: {
    RecordCard,
    LoadMore,
    IconBookingArrowRight
  },
  props: {
    records: {
      type: Array as PropType<RecordObject[]>,
      default() {
        return [];
      }
    },
    companies: {
      type: Object,
      default() {
        return {};
      }
    },
    offices: {
      type: Object,
      default() {
        return {};
      }
    },
    resources: {
      type: Object,
      default() {
        return {};
      }
    },
    services: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default() {
        return "";
      }
    },
    /**
     * The view renders this component twice; the booking control belongs to
     * the page, not to each section, so only one instance shows it.
     */
    showBooking: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headingId(): string {
      return `${this.instanceId}-heading`;
    },

    menuId(): string {
      return `${this.instanceId}-menu`;
    },

    companyList(): CompanyObject[] {
      return Object.values(this.companies);
    },

    hasMultipleCompanies(): boolean {
      return this.companyList.length > 1;
    },

    visibleRecords(): RecordObject[] {
      return this.records.slice(0, this.visibleCount);
    }
  },
  watch: {
    records() {
      this.visibleCount = this.pageSize;
    }
  },
  methods: {
    goToCompanyWebsite(company: CompanyObject): void {
      window.open(`${this.baseUrl}/${company.url}`);
    },

    handleTriggerClick(): void {
      if (this.hasMultipleCompanies) {
        this.isOpen = !this.isOpen;
        return;
      }

      const [company] = this.companyList;
      if (company) this.goToCompanyWebsite(company);
    },

    close(): void {
      this.isOpen = false;
    },

    /** Escape inside the menu returns to the control that opened it */
    closeAndRestoreFocus(): void {
      this.close();
      this.$nextTick(() => {
        (this.$refs.trigger as HTMLElement | undefined)?.focus();
      });
    },

    loadMore(): void {
      const firstNewIndex = this.visibleCount;
      this.visibleCount += this.pageSize;

      /**
       * Move to the first card of the new batch. Without this the focus stays
       * on a button that may have just disappeared, dropping keyboard users
       * back at the top of the page.
       */
      this.$nextTick(() => {
        const cards = this.$refs.cards as Vue[] | undefined;
        const target = cards && cards[firstNewIndex];
        if (target) (target.$el as HTMLElement).focus();
      });
    }
  }
});
